'use client'

import React, {useEffect} from 'react'
import {useParams} from '@/utils/navigation'
import useRouter from "@/utils/Router";

import initialProductData from "@/components/Products/initialProductData";
import Splash from "@/components/splash/Splash";




export default function Product() {
    const {sku} = useParams()
    const router = useRouter()



    const initialData = async () => {

        initialProductData(sku).then((data) => {
            const product = data?.product
            if (product?.product_profile_id) {
                router.push(`/products/sku/${product?.["sku"]}`)
            } else {
                router.push(`/products/bundle/${product?.["sku"]}`)
            }

        })
    }
    useEffect(() => {
        initialData()
    }, []);





    return (
        <div className="relative h-[100%] w-[100%]">
            <Splash text={"Please wait while we identify the product type."}/>
        </div>
    )
}
